import Entity from "./entity";
import DocumentValue from "./document-value";
import { getEmptyPeriod, sum } from "../utils";
import IPeriodValue from "../interface/period-value";
import IConfigFormulaRenewal from "../interface/field-cfg-formula-renewal";
import IConfigFormula from "../interface/field-cfg-formula";
import IField from "../interface/field";
import IEntity from "../interface/entity";
import IDocumentsTotals from "../interface/documents-totals";
import IDocumentValue from "../interface/document-value";
import IDocument from "../interface/document";
import Global from "../global";
import FormulaType from "../enum/formula-type";
import FieldType from "../enum/field-type";
import DatePeriod from "../enum/date-period";

class CollectionTotalsInstance {

    /* Public Methods */

    public get(entityId: number, docs: IDocument[]): IDocumentsTotals {
        const result: IDocumentsTotals = {};
        const entity: IEntity | null = Entity.get(entityId);
        if (entity && docs) {
            entity.fields.forEach((field: IField) => {
                let value: IDocumentValue = null;
                if (field.uiType === FieldType.number) {
                    value = this.number(docs, `c${field.id}`);
                } else if (field.uiType === FieldType.formula) {
                    const config: IConfigFormula = field.uiConfig as IConfigFormula;
                    switch(config.type) {
                        case FormulaType.number:
                            value = this.number(docs, `${Global.FORMULA_PROP_PREFIX}${field.id}`);
                            break;
                        case FormulaType.datetime:
                            value = this.period(field.id, docs, config);
                            break;
                        case FormulaType.renewal:
                            const formula: IConfigFormulaRenewal = config.formula as IConfigFormulaRenewal;
                            if (formula.showPeriod) {
                                value = this.period(field.id, docs, config);
                            }
                            break;
                    }
                }
                if (value !== null) {
                    result[field.id] = value;
                }
            });
        }
        return result;
    }

    /* Public Methods */

    private number(docs: IDocument[], prop: string): number {
        return sum(docs.map((d: IDocument) => {
            return DocumentValue.getNumber(d[prop]) || 0;
        }));
    }

    private period(fieldId: number, docs: IDocument[], config: IConfigFormula): IPeriodValue | null {
        const format: DatePeriod[] = config.format as DatePeriod[];
        if (format.length === 1) {
            const vals: number[] = [];
            docs.forEach((d: IDocument) => {
                const prop: string = `${Global.FORMULA_PROP_PREFIX}${fieldId}`;
                const value: IPeriodValue | null = DocumentValue.getPeriod(d[prop]);
                if (value) {
                    vals.push(value[format[0]] * (value.overdue ? -1 : 1));
                }
            });
            const total: number = sum(vals);
            const value: IPeriodValue = getEmptyPeriod(total < 0);
            value[format[0]] = Math.abs(total);
            return value;
        }
        return null;
    }

}

const CollectionTotals = new CollectionTotalsInstance();

export default CollectionTotals;